import React, { useState } from 'react'
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tabs,
  Tag
} from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import DocumnetForm from './components/UpdateDocumentsForm'
import { fetchDocumentByHeroId, updateDocumentByAdmin } from '../../../../modules/document'
import moment from 'moment';
import Lightbox from "react-image-lightbox";
import "../../../../../node_modules/react-image-lightbox/style.css";

export const HeroDocument = ({ data }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [current, setCurrent] = useState('')
  const [formData, setFormData] = useState({})
  const { heroDocument, isLoading } = useSelector(
    (state) => ({
      heroDocument: state.document.heroDocument,
      isLoading: state.document.isLoading
    }),
    []
  )
  function fetch() {
    dispatch(fetchDocumentByHeroId(data.id))
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await fetch()
    await setVisible(false)
  }

  const onOk = async (data) => {
    await dispatch(updateDocumentByAdmin(data))
    await fetch()
    await setVisible(false)
    await setFormData({})
  }

  const isPdf = (url) => {
    if (!url) return false
    try {
      return new URL(url).pathname.toLowerCase().endsWith('.pdf')
    } catch (e) {
      return url.split('?')[0].toLowerCase().endsWith('.pdf')
    }
  }

  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  useDeepEffect(() => {
    if (!isEmpty(data)) {
      fetch()
    }
  }, [data])

  const columns = [
    {
      title: 'Document',
      dataIndex: 'docName',
      key: 'docName'
    },
    {
      title: 'File',
      key: 'image',
      dataIndex: 'image',
      render: (image, record) =>
        isPdf(image) ?
        <a href={image} target="_blank" rel="noopener noreferrer">
          <Icon type="file-pdf" style={{ fontSize: 48, color: '#f5222d' }} />
          <div>เปิดไฟล์ PDF</div>
        </a> :
        <span>
          <img
            src={image}
            width={100}
            height={100}
            style={{ marginRight: 10, objectFit: 'cover' }}
            alt="img"
            onClick={e => handleClickImage(e, image)}
          />
          {current && (
            <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
          )}
        </span>
    },
    {
      title: 'Expired',
      dataIndex: 'expired',
      key: 'expired',
      render: (expired) => {
        const dateExpired = GetDate(expired)
        return (
          <span>
            {dateExpired}
          </span>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Submit Date',
      dataIndex: 'createAt',
      key: 'createAt',
      render: (createAt) => {
        const datesubmit = GetDateTime(createAt)
        return (
          <span>
            {datesubmit}
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const GetStatusColor = (status) => {
    let color = ''
    if (status !== null) {
      switch (status.toUpperCase()) {
        case 'PENDING':
          color = 'gold'
          break
        case 'APPROVED':
          color = 'green'
          break
        case 'REJECT':
          color = 'red'
          break
        case 'EXPIRED':
          color = 'volcano'
          break
        default:
          break
      }
    }
    return color
  }
  const GetDate = (expired) => {
    let date = ''
    if (expired !== null) {
      date = moment(expired).format('DD/MM/YYYY')
    }
    return date
  }
  const GetDateTime = (datetime) => {
    let submitdate = ''
    if (datetime !== null) {
      submitdate = moment(datetime).format('DD/MM/YYYY HH:mm')
    }
    return submitdate
  }

  return (
    <Card>
      <Table
        loading={isLoading}
        rowKey={(record) => record.id}
        dataSource={heroDocument}
        columns={columns}
      />
      <DocumnetForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>

  )
}

export default HeroDocument